import React, { useEffect, useState } from "react";
import { spin } from "../../Common/NewLoader";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../withRouter";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import CustomerService from "../../Masters/Customers/CustomerService";
import { currentTenant, userid } from "../../Common/Credentials";
import { Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import SalesServices from "../../Sales/SalesServices";
import DirectDNCNServices from "./DirectDNCNServices";
import SupplierService from "../../Masters/Suppliers/SupplierService";
import AgentServices from "../../Masters/Agents/AgentServices";

const newDirectCNDN = () => {
  const navigate = useNavigate()
    const [loading,setIsLoading] = useState(false)
    const [customerslist,setCustomerslist] = useState([])
    const [supplierslist,setSupplierslist] = useState([])
    const [agentslist,setAgentslist] = useState([])
    const [error,setError] = useState(false)
    const [data,setData] = useState({
        type:"Credit",
        customer:null,
        against:"Customer",
        amount:0,
        description:""
    })

    useEffect(() => {
        CustomerService.retriveAllCustomers(currentTenant).then((res)=>{
            setCustomerslist(res.data === "" || res.data === undefined
            ? []
            : res.data)
        })

        SupplierService.retriveAllSuppliers(currentTenant).then((res)=>{
          setSupplierslist(res.data === "" || res.data === undefined
          ? []
          : res.data.map(e=>{return{...e,type:"Supplier"}}))
        })

        AgentServices.getAgents(currentTenant).then((res)=>{
          setAgentslist(res.data === "" || res.data === undefined
          ? []
          : res.data.map(e=>{return{...e,type:"Agent",companyname:e.name}}))
        })

      }, [])

    const handleChange = (name,value) =>{
        console.log(name,value)
        let temp = {...data}
        temp[name] = value
        setData({...temp})
    }

    const validate = () =>{
      if([null,"",0].includes(data.amount)){
        return false
      }else if([null,"",undefined].includes(data.company)){
        return false
      }else if([null,"",undefined].includes(data.description)){
        return false
      }else{
        return true
      }
      
    } 

    const onSubmit = (e) =>{
      e.preventDefault();
      if(validate()){
        let formdata = {...data,companyid:data.company.id,ledgerid:data.company.ledgerid,companyname:data.company.companyname,tenantId:currentTenant,createdby:userid,updatedby:userid,accstatus:"Pending"}
        DirectDNCNServices.generatedirectcndn(formdata).then(()=>navigate("/salesdirectcndn"))
      }else{
        setError(true)
      }
    }

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item text-secondary">
              <Link to="/accounts">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary" ><Link to="/salesdirectcndn">Direct CN/DN</Link></li>
            <li className="breadcrumb-item active">New Direct CN/DN</li>
          </ol>

          <div className="card">
              <div className="card-header">
                <h3 className="card-title">Direct CN/DN</h3>
              </div>

              <div className="card-body py-3">
                    <div>
                      {loading === true ? (
                        <div className="text-center">{spin}</div>
                      ) : (
                        <>
                          <form className="row" onSubmit={onSubmit}>
                          <fieldset className="form-group col-md-4">
                                    <FormControl variant="standard" fullWidth>
                                      <InputLabel id="demo-simple-select-standard-label">
                                        Type
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={data.type}
                                        name="type"
                                        onChange={(e)=>handleChange(e.target.name,e.target.value)}
                                        label="Type"
                                      >
                                        <MenuItem value={"Credit"}>
                                          Credit Note
                                        </MenuItem>
                                        <MenuItem value={"Debit"}>Debit Note</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </fieldset>
                                  <fieldset className="form-group col-md-4">
                                    <FormControl variant="standard" fullWidth>
                                      <InputLabel id="demo-simple-select-standard-label">
                                        Against
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={data.against}
                                        name="against"
                                        onChange={(e)=>handleChange(e.target.name,e.target.value)}
                                        label="Against"
                                      >
                                        <MenuItem value={"Customer"}>
                                          Customer
                                        </MenuItem>
                                        <MenuItem value={"AgentorSupplier"}>Agent/Supplier</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </fieldset>

                                  <fieldset className="form-group col-md-4">
                                  {data.against === "Customer"?
                            <Autocomplete
                              id="subaccount"
                              className="subacc-select"
                              name="company"
                              options={customerslist}
                              getOptionLabel={(option) => option.companyname}
                              value={data.company}
                              onChange={(e,value)=>handleChange("company",value)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  type="text"
                                  name="company"
                                  value={data.company}
                                  label="Select Customer"
                                  variant="standard"
                                  fullwidth="true"
                                  error={error && [null,"",undefined].includes(data.company)}

                                />
                              )}
                            />:
                            <Autocomplete
                              id="subaccount"
                              className="subacc-select"
                              name="company"
                              options={[...supplierslist,...agentslist]}
                              groupBy={(option)=>option.type}
                              getOptionLabel={(option) => option.companyname}
                              value={data.company}
                              onChange={(e,value)=>handleChange("company",value)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  type="text"
                                  name="company"
                                  value={data.company}
                                  label="Select Agent/Supplier"
                                  variant="standard"
                                  fullwidth="true"
                                  error={error && [null,"",undefined].includes(data.company)}

                                />
                              )}
                            />}
                          </fieldset>
                          <fieldset className="form-group col-md-4">
                          <TextField
                                  className="form-control"
                                  type="number"
                                  name="amount"
                                  onChange={(e)=>handleChange(e.target.name,e.target.value)}
                                  value={data.amount}
                                  label={`Enter Amount`}
                                  variant="standard"
                                  fullwidth="true"
                                  error={error && [null,"",0].includes(data.amount)}
                                />
                            </fieldset>
                            <fieldset className="form-group col-md-12 mt-2">
                          <TextField
                                  className="form-control"
                                  type="text"
                                  name="description"
                                  onChange={(e)=>handleChange(e.target.name,e.target.value)}
                                  value={data.description}
                                  label={`Enter Description`}
                                  variant="standard"
                                  fullwidth="true"
                                  error={error && [null,""].includes(data.description)}
                                />
                            </fieldset>
                            <fieldset className="form-group col-md-12 d-flex">
                            {loading ? (
                        <button className="btn btn-sm hovbuttonColour" disabled >
                          <Spinner animation="border" size="sm" />
                          &nbsp;{"Saving"}
                          </button>
                      ) : (
                          <button className="btn btn-sm hovbuttonColour" type="submit">Save</button>
                        )
                    }
                    <Link
                      as="button"
                      className="btn btn-sm deletebutton ml-1"
                      to={{ pathname: "/salesdirectcndn"}}
                      >Close</Link>
                      </fieldset>
                          </form>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
  );
};

export default  withRouter(newDirectCNDN);
